export default "__VITE_ASSET__BIMqytBq__ 640w, __VITE_ASSET___Mzu024K__ 1024w, __VITE_ASSET__lYV4BEVu__ 1920w";